import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SelectInput } from '../components/fields'
import subjectsMessages from '../../common/translations/subjectsMessages'
import { setCurrentLocale } from '../../common/intl/actions'
import { loadSubjects } from '../../common/subjects/actions'
import { fields } from '../../common/lib/redux-fields'
import { validateLanguagesSelect } from '../../common/users/validations'
import formValidation from '../../common/lib/formValidation'
import { roles, langs, languages } from '../../common/config'
import { Button, BottomButton, RadioInput, BackLink, LanguagePicker, Title } from '../components'


class SetLanguagesForm extends React.Component {
  constructor(props) {
    super(props)

    this.form = React.createRef()
  }

  componentDidMount() {
    const { location, fields, loadSubjects } = this.props
    const redirectUrl = location && location.search
    if (redirectUrl.includes('test')) {
      fields.$setValue('role', roles.USER)
    }
    loadSubjects()

    /* preload images */
    const countryCodes = ['cs', 'en', 'de', 'fr', 'sk', 'es', 'pt']
    countryCodes.forEach(code => {
      const img = new Image()
      img.src = `/assets/images/flags/${code}.png`
    })
  }

  continue() {
    const { step } = this.props.fields

    const newStep = step.value + 1
    step.onChange({ value: newStep })
    if (newStep === 3) {
      setTimeout(() => this.continue(), 700)
    }
  }

  back() {
    const { step } = this.props.fields
    let newStep = step.value - 1
    if (newStep === 3) {
      newStep -= 1
    }
    step.onChange({ value: newStep })
  }

  async submitForm(e) {
    if (e) {
      e.preventDefault()
    }
    const { fields, history, location, submit, firstUrl } = this.props
    const redirectUrl = location && location.search
    const values = { ...fields.$values() }
    const userInfo = { ...values, subjects: [values.subjects] }

    if (await submit(userInfo)) {
      history.push('/sign-up-form')
      /*
      if (values.role === roles.TEACHER || firstUrl !== '/') {
        history.push('/sign-up-form')
      } else {
        const langs = `${values.foreignLanguage}-${values.userLanguage}`
        history.push(`/vocabulary-learn/onboarding-${langs}`)
      }
      */
    }
  }

  render() {
    const { fields, errorMessage, intl } = this.props

    const isTeacher = fields.role.value === roles.TEACHER

    return (
      <form onSubmit={(e) => this.submitForm(e)}>
        {
          fields.step.value === 1 &&
          <div className="flex-column items-center">
            <div className="user-form-back">
              <Link to="/">
                <FontAwesomeIcon icon="arrow-left" size="2x" />
              </Link>
            </div>
            <Title message={intl.formatMessage(messages.signUpAs)} />
            <h1>{intl.formatMessage(messages.signUpAs)}</h1>
            <div className="role-field">
              <div
                className={`role-item-field ${fields.role.value === roles.USER ? 'active' : ''}`}
                onClick={() => fields.role.onChange({ value: roles.USER })}
              >
                <RadioInput
                  id="student"
                  type="radio"
                  name="role"
                  value={roles.USER}
                  checked={fields.role.value === roles.USER}
                  onChange={() => {
                    fields.role.onChange({ value: roles.USER })
                  }}
                  label={intl.formatMessage(messages.student)}
                />
              </div>
              <div
                className={`role-item-field ${fields.role.value === roles.TEACHER ? 'active' : ''}`}
                onClick={() => fields.role.onChange({ value: roles.TEACHER })}
              >
                <RadioInput
                  id="teacher"
                  type="radio"
                  name="role"
                  value={roles.TEACHER}
                  checked={fields.role.value === roles.TEACHER}
                  onChange={() => {
                    fields.role.onChange({ value: roles.TEACHER })
                  }}
                  label={intl.formatMessage(messages.teacher)}
                />
              </div>
            </div>
            <BottomButton
              disabled={!fields.role.value}
              onClick={() => this.submitForm()}
              buttonText={intl.formatMessage(messages.continue)}
            />
          </div>
        }
        {
          fields.step.value === 2 &&
          <React.Fragment>
            <div className="user-form-back">
              <FontAwesomeIcon
                onClick={() => this.back()}
                icon="arrow-left"
                size="2x"
              />
            </div>
            <h2 id="sign-up-learning-language">{intl.formatMessage(messages.learningLanguage)}</h2>
            <LanguagePicker
              field={fields.foreignLanguage}
              itemClick={(value) => {
                fields.foreignLanguage.onChange({ value })
                this.continue()
              }}
            />
          </React.Fragment>
        }
        {
          fields.step.value === 3 &&
          <div className="app-loader" />
        }
        {
          fields.step.value === 4 &&
          <React.Fragment>
            <div className="user-form-back">
              <FontAwesomeIcon
                onClick={() => this.back()}
                icon="arrow-left"
                size="2x"
              />
            </div>
            <h2 id="sign-up-user-language">{intl.formatMessage(messages.matureLanguage)}</h2>
            <LanguagePicker
              field={fields.userLanguage}
              itemClick={(value) => {
                fields.userLanguage.onChange({ value })
                this.submitForm()
              }}
            />
          </React.Fragment>
        }
        {errorMessage}
      </form>
    )
  }
}

SetLanguagesForm.defaultProps = {
  errorMessage: '',
  redirectAfterAuth: '',
  firstUrl: '',
  subjects: [],
}

SetLanguagesForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  subjects: PropTypes.array,
  errorMessage: PropTypes.any,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  setCurrentLocale: PropTypes.func.isRequired,
  loadSubjects: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  redirectAfterAuth: PropTypes.string,
  firstUrl: PropTypes.string,
}

SetLanguagesForm = withRouter(SetLanguagesForm)

const enhance = compose(
  connect((state) => ({
    viewer: state.users.viewer,
    registeringUser: state.users.registeringUser,
    subjects: state.subjects.all,
    firstUrl: state.app.firstUrl,
  }), { setCurrentLocale, loadSubjects }),
  formValidation(props => ({
    validationFunc: validateLanguagesSelect,
    submitFunc: props.submit,
  })),
  fields({
    path: 'SetLanguagesForm',
    fields: [
      'userLanguage',
      'foreignLanguage',
      'role',
      'step',
    ],
    getInitialState: () => ({
      role: '', // roles.TEACHER,
      userLanguage: '',
      foreignLanguage: '',
      subjects: null,
      step: 1,
    }),
  }),
  injectIntl,
)

export default enhance(SetLanguagesForm)

const messages = defineMessages({
  greeting: {
    id: 'setLanguages.form.greeting',
    defaultMessage: 'Dobrý deň',
  },
  signUpAs: {
    id: 'setLanguages.form.signUpAs',
    defaultMessage: 'Ste študent alebo učiteľ?',
  },
  languageSelect: {
    id: 'setLanguages.form.languageSelect',
    defaultMessage: 'Vyberte si Vaše jazyky',
  },
  teacher: {
    id: 'base.teacher',
    defaultMessage: 'Som učiteľ',
  },
  student: {
    id: 'base.student',
    defaultMessage: 'Som študent, samouk',
  },
  matureLanguage: {
    id: 'base.matureLanguage',
    defaultMessage: 'Rodný jazyk',
  },
  teachingLanguage: {
    id: 'base.teachingLanguage',
    defaultMessage: 'Ktorý jazyk učíte?',
  },
  learningLanguage: {
    id: 'base.learningLanguage',
    defaultMessage: 'Ktorý jazyk sa učíte?',
  },
  continue: {
    id: 'base.continue',
    defaultMessage: 'Pokračovať',
  },
  languageLabel: {
    id: 'setLanguages.form.languageLabel',
    defaultMessage: 'Vyberte jayzk',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/SetLanguagesForm.js